// WOMEN & MEN LIST
<template>
    <div class="list-wrapper" ref="listBox">
        <template v-if="list && list.length">
            <div
                class="model-list"
                @click="handleDetail(item)"
                v-for="(item, index) in list"
                :key="index"
            >
                <div
                    class="cover"
                    :style="{ 'background-image': 'url(' + item.link + ')' }"
                ></div>
                <div class="mask"></div>
                <div class="name">
                    <span>{{ item.last_name }}</span>
                    <span>{{ item.first_name }}</span>
                </div>
            </div>
        </template>

        <el-empty v-else-if="!loading" description="No relevant content">
            <!-- <span slot="description"></span> -->
        </el-empty>
    </div>
</template>

<script>
export default {
    name: 'model-list',

    data() {
        return {
            page: 1,
            list: [],
            loading: false,
            lock: false,
            isEnd: false,
        };
    },

    watch: {
        $route() {
            this.page = 1;
            this.lock = false;
            this.isEnd = false;
            this.list = [];
            this.fetchList(this.page);
        },
    },

    methods: {
        fetchList(page) {
            if (this.isEnd) return;

            const sex = this.$route.query.sex || 1;
            this.loading = true;
            this.$http
                .getModelList({
                    sex,
                    page,
                    limit: 10,
                })
                .then((res) => {
                    this.page = page;
                    const data = res.list;
                    if (data && data.length > 0) {
                        this.list = this.list.concat(data);
                    }

                    if (res.count === this.list.length) {
                        this.isEnd = true;
                    }
                })
                .finally(() => (this.loading = false));
        },
        handleDetail(item) {
            this.$router.push({ name: 'detail', params: { id: item.id } });
        },

        computedOffset(obj, prop) {
            if (obj === document.body || obj.offsetParent === document.body) {
                return parseInt(obj[prop], 10);
            }
            return (
                parseInt(obj[prop], 10) +
                this.computedOffset(obj.offsetParent, prop)
            );
        },
    },

    created() {
        this.fetchList(1);
    },

    mounted() {
        window.onscroll = () => {
            // 瀑布流盒子
            const box = this.$refs.listBox;
            const top = this.computedOffset(box, 'offsetTop');
            const height = box.offsetHeight;
            const clientHeight = document.documentElement.clientHeight;
            const scrollTop = document.documentElement.scrollTop;
            if (
                top + height < clientHeight + scrollTop + 50 &&
                !this.lock
            ) {
                this.lock = true;
                this.fetchList(this.page + 1);
            }
        };
    },
};
</script>

<style lang="scss" scoped>
.list-wrapper {
    display: flex;
    flex-wrap: wrap;
    font-family: Didot-Bold, Didot;
    align-items: center;
    padding: 0 0 40px;
    box-sizing: border-box;
    @include media-mob {
        padding: 0 20px 20px;
    }
}
.model-list {
    width: calc((100% - 120px) / 4);
    margin: 40px 40px 0 0;
    height: 550px;
    border-radius: 20px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    @include media-mob {
        width: calc((100% - 10px) / 2);
        height: 240px;
        margin: 10px 10px 0 0;
        border-radius: 10px;
        &:nth-child(2n) {
            margin-right: 0;
        }
        &:first-child, &:nth-child(2) {
            margin-top: 0;
        }
    }
    &:nth-child(4n) {
        margin-right: 0;
    }
    .cover {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
    }
    &:hover {
        .mask, .name {
            opacity: 0;
        }
    }
    .mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.3);
        transition: all 0.4s;
    }
    .name {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        position: absolute;
        z-index: 2;
        left: 50%;
        transform: translateX(-50%);
        bottom: 40px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        transition: all 0.2s;
        @include media-mob {
            bottom: 10px;
        }
        span {
            font-size: 24px;
            font-weight: 900;
            color: #ffffff;
            line-height: 28px;
            letter-spacing: 3px;
            @include media-mob {
                font-size: 13px;
                line-height: 14px;
            }
        }
    }
}
</style>
